<template>
  <div
      v-if="isShowPop"
      :class="['ceiba-dialog-container',
       'ceiba-dialog--default',
       !isMobile ? 'ceiba-dialog--pc' : '',
        isBottomType ? 'ceiba-dialog-bottom' : 'ceiba-dialog-container'
       ]"
  >
    <transition>
      <div
          v-if="isShowPop && options.isShowMask"
          class="ceiba-dialog-mask"
          @click="handleClickMask"
      ></div>
    </transition>
    <div
        :class="[
        isBottomType ? 'ceiba-dialog-wrap-isBottom' : 'ceiba-dialog-wrap',
        isBottomType && onCloseAnimation ? 'ceiba-dialog-wrap-isBottom-close-animation' : '',
        !isBottomType && onCloseAnimation ? 'ceiba-dialog-wrap-close-animation' : '',
        ]"
        :style="baseDialogWrap"
    >
    <div v-if="threeImageOption.enable" class="ceiba-dialog-main-bg" :style="threeMainStyle">
      <div  class="ceiba-dialog-main-bg-header" :style="threeHeaderStyle">
    </div>
    <div class="ceiba-dialog-main-bg-body" :style="threeRepeatStyle">

    </div>
    <div
      class="ceiba-dialog-main-bg-footer"
      :style="threeFooterStyle">
    </div>
    </div>
      <div :class="[
        isBottomType ? 'ceiba-dialog-main-bottom' : 'ceiba-dialog-main',
        !isMobile ?'ceiba-dialog-main-pc' : ''
      ]"
           :style="mainStyle">
        <div class="ceiba-dialog-hd" v-if="options.header !== false" :style="entityThreeHeaderStyle">
          <slot name="header">
            <h3
                class="ceiba-dialog-title"
                :style="!isMobile ? '' : titleStyle"
                v-if="typeof options.header === 'string' && !isBottomType"
            >{{ options.header }}</h3>

            <h3
                class="ceiba-base-bottom-dialog-title"
                :style="bottomTypeTitleStyle"
                v-if="typeof options.header === 'string' && isBottomType"
            >{{ options.header }}</h3>
          </slot>
        </div>

        <div
          :style="entityThreeRepeatStyle"
         :class="[
          isBottomType ? 'ceiba-dialog-bd-bottom' : 'ceiba-dialog-bd',
          ]"
          ref="dialogBody"
          >
          <slot name="body"></slot>
        </div>
        <div
          :style="entityThreeFooterStyle"
          class="ceiba-dialog-ft"
          ref="dialogFooter"
          v-if="options.footer !== false"
          >
          <slot name="footer">
            <template v-if="options.cancel !== false">
              <a
                  class="ceiba-dialog-ft-btn-simple"
                  href="javascript:;"
                  @click="handleCancel"
                  :style="!isMobile ? '' : options.cancelStyle"
                  v-if="typeof options.cancel === 'string'"
              >
                <span class="ceiba-dialog-ft-btn-simple-label">{{ options.cancel }}</span>
              </a>
              <button
                  type="button"
                  :style="!isMobile ? '' : options.cancelStyle"
                  v-else
                  class="ceiba-dialog-ft-button"
                  @click="handleCancel"
              ></button>
            </template>
            <template v-if="options.confirm !== false">
              <a
                  class="ceiba-dialog-ft-btn-simple ceiba-dialog-ft-btn-simple--primary"
                  href="javascript:;"
                  @click="handleConfirm"
                  :style="!isMobile ? '' : options.confirmStyle"
                  v-if="typeof options.confirm === 'string'"
              >
                <span class="ceiba-dialog-ft-btn-simple-label">{{ options.confirm }}</span>
              </a>
              <button
                  type="button"
                  :style="!isMobile ? '' : options.confirmStyle"
                  v-else
                  class="ceiba-dialog-ft-button"
                  @click="handleConfirm"
              ></button>
            </template>
          </slot>
        </div>
        <template v-if="options.close !== false">
          <div :style="closeOptionStyle" :class="[
            options.closeLocation === 'bottom-center' ? 'ceiba-dialog-close-bottom-center': '',
            options.closeLocation === 'right-top' ? 'ceiba-dialog-close-right-top': '',
            options.closeLocation === 'top-right' ? 'ceiba-dialog-close-top-right': '',
            options.closeLocation === 'in-right-top' ? 'ceiba-dialog-close-in-right-top': '',
            options.closeLocation === 'top-right-isBottom' ? 'ceiba-dialog-close-top-right-isBottom': ''

            ]">
            <button
              type="button"
              :style="closeButtonStyle"
              v-if="options.closeStyle && JSON.stringify(options.closeStyle) !== '{}'"
              @click="handleClose"
          ></button>
          <a
              href="javascript:;"
              :style="positionBottomCloseStyle"
              @click="handleClose"
              v-else
            >×</a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
const PositionBottom =  'bottom';
const PositionCenter =  'center';
export default {
  name: 'CDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      onCloseAnimation: false,
      onCloseAnimationTimeId: null,
      isShowPop: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      options: Object.assign(
        {
          height: this.isMobile ? '5rem' : '300px',
          width: this.isMobile ? '6rem' : '600px',
          controlClass: '', // 自定义类名
          color: this.isMobile ? '#ffffff' : '#000000',
          backgroundImage: '', // 个性化弹框背景
          header: '温馨提示',
          footer: false,
          confirmStyle: '', // 个性化弹框确定按钮自定义样式
          cancelStyle: '', // 个性化弹框取消按钮自定义样式
          closeStyle: '', // 个性化弹框关闭按钮自定义样式
          confirm: false,
          cancel: false,
          close: true,
          closeLocation: this.isMobile ? 'bottom-center' : 'top-right',
          isShowMask: true,
          maskClickable: true, // 蒙层是否点击可关闭
          isConfirmClose: true,
          titleStyle: {},
          positionType: 'center',
          // popName: '', //上报作用
        },
        this.option,
      ),
      titleHeight: '1rem', // 默认标题高度 1rem
      titleColor: '#000000',
      threeImageOption: {
        enable: false, // 是否三切图模式
        headerImage: '', // 顶部切图
        headerWidthRatio: 0, // 顶部切图高宽比
        repeatImage: '', // 中部填充切图
        repeatWidthRatio: 0, // 中度切图高宽比（暂时没用到）
        fotterImage: '', // 底部切图
        fotterWidthRatio: 0, // 底部切图高宽比
      },
      threeRepeatHeight: 0, // 内容主体高度
      threeFooterHeight: 0, // 底部高度
    };
  },
  computed: {
    // rem 转 px的时候 实际乘数
    multiplier() {
      if (this.$isInEditor) {
        return 100;
      }
      console.log('this.rootFontSize=', Vue.prototype?.$storeInstance?.getters?.rootFontSize);
      const fontSize = Vue.prototype?.$storeInstance?.getters?.rootFontSize;
      return fontSize ? parseFloat(fontSize.substring(0, fontSize.length - 2), 3) : 50;
    },
    /**
     * 弹窗高度 = 头部高度（默认1rem） + 内容主体高度（动态计算的高度）+ 底部高度（默认pc 80px 移动端1.44rem）+ 上边距(默认0) + 下边距（默认0）
     */
    getDialogHeight() {
      const headerHeight = this.parsePxValue(this.titleHeight);
      const bodyHeight = this.threeRepeatHeight;
      const footerHeight = this.threeFooterHeight ? this.threeFooterHeight : this.parsePxValue(!this.isMobile ? '80px' : '1.44rem');
      const dialogHeight = headerHeight + bodyHeight + footerHeight
      + this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingTop || '0px'))
      + this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingBottom || '0px'));
      console.log('dialogHeight', headerHeight, bodyHeight, footerHeight, dialogHeight, this.threeFooterHeight);
      return dialogHeight;
    },
    threeMainStyle() {
      if (!this.threeImageOption.enable) return {};
      const width = !this.isMobile ? '600px' : this.options.width;
      return {
        width: `${this.isBottomType ? '100%' : width}`,
      };
    },
    // 三切图弹窗头部切图背景
    threeHeaderStyle() {
      if (!this.threeImageOption.enable) return {};
      return {
        height: `${this.ratioToHeaderHeight}px`,
        background: 'no-repeat 0 0',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.threeImageOption.headerImage})`,
        // 三切图拼接处防止取小数位导致的断层
        marginTop: `${this.parsePxValue(!this.isMobile ? '1px' : '0.01rem')}px`,
      };
    },
    // 动态计算实际存在的实际头部高度 默认走三切图的高度，如果配置了标题高度走配置的标题高度
    entityThreeHeaderStyle() {
      if (!this.threeImageOption.enable) return {};
      let threeHeaderHeight = this.ratioToHeaderHeight;
      if (Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleHeight) {
        threeHeaderHeight = this.parsePxValue(Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleHeight);
      }
      return {
        height: `${threeHeaderHeight}px`,
      };
    },
    // 三切图弹窗主体内容切图背景
    threeRepeatStyle() {
      if (!this.threeImageOption.enable) return {};
      // 中间背景图渲染的区域高度 = 弹窗总高度 - 头部切图高度 - 底部切图高度
      const threeRepeatHeight = this.getDialogHeight - this.ratioToHeaderHeight - this.ratioToFooterHeight;
      console.log('threeRepeatHeight==', threeRepeatHeight);
      return {
        height: `${threeRepeatHeight}px`,
        background: 'repeat-y 0 0',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.threeImageOption.repeatImage})`,
      };
    },
    // 动态计算实际存在的主体高度
    entityThreeRepeatStyle() {
      // minHeight作用为防止中间内容区域高度小于默认的1.2rem高度
      let minHeight = {
        minHeight: `${this.parsePxValue(!this.isMobile ? '60px' : '1.2rem')}px`,
      };
      // 当实际渲染的主体高度大于等于 默认高度时，则使用组件实际渲染的高度
      if (this.threeRepeatHeight >= this.parsePxValue(!this.isMobile ? '60px' : '1.2rem')) {
        minHeight = {
          minHeight: `${this.threeRepeatHeight}px`,
        };
      }
      // 当底部设置为false时，中间高度为60px ，比底部默认高度小，所以取底部的大值，中间实际渲染区域高度为底部高度
      if (this.options.footer === false) {
        minHeight = {
          minHeight: `${this.parsePxValue(!this.isMobile ? '80px' : '1.44rem')}px`,
        };
      }
      // 当底部和头部同时设置为false时，中间实际渲染区域最小高度为底部高度 加 头部高度
      if (this.options.footer === false && this.options.header === false) {
        minHeight = {
          minHeight: `${this.parsePxValue(!this.isMobile ? '180px' : '2.44rem')}px`,
        };
      }
      // 底部弹窗
      if (this.isBottomType) {
        return {};
      }
      return {
        //  移动端固定的宽度6rem pc端固定宽度 600px
        width: `${this.parsePxValue(!this.isMobile ? '600px' : '6rem')}px`,
        ...minHeight,
      };
    },
    // 三切图弹窗底部内容切图背景
    threeFooterStyle() {
      if (!this.threeImageOption.enable) return {};
      return {
        height: `${this.ratioToFooterHeight}px`,
        background: 'no-repeat 0 0',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.threeImageOption.fotterImage})`,
      };
    },
    // 底部实际渲染区域样式
    entityThreeFooterStyle() {
      let footerWidth = this.parsePxValue(!this.isMobile ? '600px' : '6rem');
      let threeFooterHeight = parseFloat(this.parsePxValue((!this.isMobile ? '80px' : '1.44rem')), 3);
      // 移动端 超过默认配置最小底部高度时 使用传入的底部高度
      if (this.isMobile && this.threeFooterHeight >= this.parsePxValue(!this.isMobile ? '80px' : '1.44rem')) {
        threeFooterHeight = this.threeFooterHeight;
      }
      // 底部弹窗
      if (this.isBottomType) {
        footerWidth = this.parsePxValue('7.5rem');
      }
      // 移动端与pc端的样式不一样
      return {
        minHeight: `${threeFooterHeight}px`,
        paddingBottom: `${this.parsePxValue(!this.isMobile ? '0px' : '0.16rem')}px`,
        paddingLeft: `${this.parsePxValue(!this.isMobile ? '0px' : '0.2rem')}px`,
        paddingRight: `${this.parsePxValue(!this.isMobile ? '0px' : '0.2rem')}px`,
        width: `${footerWidth}px`,
      };
    },
    baseDialogWrap() {
      const width = !this.isMobile ? '600px' : this.options.width;
      return  {
        width: `${this.isBottomType ? '100%' : width}`,
        '--onPopHeight': `-${this.getDialogHeight}px`,
      };
    },
    positionBottomCloseStyle() {
      const buttonStyle = {
        backgroundSize: '100% 100%',
        width: !this.isMobile ? '40px' : '0.64rem',
        height: !this.isMobile ? '40px' : '0.64rem',
        lineHeight: !this.isMobile ? '40px' : '0.64rem',
        textAlign: 'center',
      };

      if (this.options.closeLocation === 'top-right-isBottom') {
        return  {
          ...buttonStyle,
          color: this.options?.dialogStyle?.color  ??  '#ffffff',
          opacity: '0.4',
        };
      }
      return   {
        ...buttonStyle,
        color: '#ffffff',
      };
    },
    isBottomType() {
      // 默认居中 isBottom 为了兼容 这个字段扩展性不友好 去掉
      const { positionType = PositionCenter, isBottom = false } = this.options;
      if (isBottom === true) return  true;
      return positionType === PositionBottom ;
    },
    mainStyle() {
      const width = !this.isMobile ? '600px' : this.options.width;
      const styles = {
        width: `${this.isBottomType ? '100%' : width}`,
        paddingTop: `${this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingTop || '0px'))}px`,
        paddingBottom: `${this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingBottom || '0px'))}px`,
        color: this.options?.dialogStyle?.color || (!this.isMobile ? '#000000' : '#ffffff'),
        // minHeight: `${this.getDialogHeight}`,
      };
      if (this.options.dialogStyle) {
        if (this.options.dialogStyle.backgroundImage) {
          if (this.threeImageOption.enable) {
            return styles;
          }
          return Object.assign(styles, this.options.dialogStyle);
        }
        return Object.assign(styles, this.options.dialogStyle, {
          backgroundColor: '#fff',
          width: `${this.isBottomType ? '100%' : width}`,
        });
      }
      return Object.assign(styles, {
        backgroundColor: '#fff',
      });
    },
    titleStyle() {
      let color = { r: 0, g: 0, b: 0 };
      if (this.titleColor) {
        color = this.parseColor(this.titleColor);
      } else if (this.options.dialogStyle) {
        color = this.parseColor(this.options.dialogStyle.color);
      }
      return {
        // borderBottom: `0.04rem solid rgba(${color.r},${color.g},${color.b},.3)`,
        color: `rgb(${color.r},${color.g},${color.b})`,
        height: this.titleHeight,
        lineHeight: this.titleHeight,
        ...this.options.titleStyle,
        marginBottom: '0rem',
        marginTop: '0rem',
        padding: '0rem',
      };
    },
    bottomTypeTitleStyle() {
      return {
        ...this.options.titleStyle,
      };
    },
    // 关闭按钮样式
    closeButtonStyle() {
      let buttonStyle = {
        backgroundSize: '100% 100%',
        width: !this.isMobile ? '40px' : '0.64rem',
        height: !this.isMobile ? '40px' : '0.64rem',
      };
      if (this.options.closeLocation === 'top-right-isBottom') {
        buttonStyle = {
          backgroundSize: '100% 100%',
          width: !this.isMobile ? '40px' : '0.64rem',
          height: !this.isMobile ? '40px' : '0.64rem',
        };
      }

      console.log('buttonStyle', buttonStyle);

      return {
        ...this.options.closeStyle,
        ...buttonStyle,
      };
    },
    closeOptionStyle() {
      const paddingHorizon = (
        this.parsePxValue(Vue.prototype?.$storeInstance?.getters?.dialogConfig?.width) - this.parsePxValue(!this.isMobile ? '600px' : '6rem')) / 2;
      return {
        width: !this.isMobile ? '48px' : this.titleHeight,
        height: !this.isMobile ? '48px' : this.titleHeight,
        '--valueTop': `${this?.parsePxValue(Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingTop || '0px')}px`,
        '--valueRight': `${paddingHorizon || 0}px`,
        '--valueTitleHeight': `-${this.parsePxValue(this.titleHeight || '1rem')}px`,
      };
    },
    // 根据头部切图比例计算的头部高度
    ratioToHeaderHeight() {
      return parseFloat(this.parsePxValue((!this.isMobile ? '600px' : this.options.width)) * this.threeImageOption.headerWidthRatio, 3);
    },
    // 根据底部切图比例计算的底部高度
    ratioToFooterHeight() {
      return parseFloat(this.parsePxValue((!this.isMobile ? '500px' : this.options.width)) * this.threeImageOption.fotterWidthRatio, 3);
    },
  },
  watch: {
    value: {
      handler(newVal, oldValue) {
        // 关闭 触发css 动画
        if (newVal === false && !!oldValue === true) {
          this.onCloseAnimation = true;
          // 关闭
          const that = this;
          this.onCloseAnimationTimeId = setTimeout(() => {
            that.isShowPop = false;
          }, 200);
          return;
        }
        // 打开的 切换className 实现css动画
        if (newVal === true && !!oldValue === false) {
          this.onCloseAnimation = false;
          this.isShowPop = true;
          this.initDialogHeight();
          this.reportFunc(1001, 'show_pop', { pop_name: `${this.options.popName || ''}` });
        }
      },
      immediate: true,
    },
    option: {
      immediate: true,
      handler(newVal) {
        this.options = Object.assign(this.options, newVal);
        this.initDialogOption();
      },
    },
  },
  mounted() {
    this.initDialogOption();
  },
  beforeDestroy() {
    // 某种情况先可能出现
    if (this.onCloseAnimationTimeId) {
      clearTimeout(this.onCloseAnimationTimeId);
    }
  },
  methods: {
    initDialogOption() {
      console.log('options', this.options, this.option);
      // 处理标题行高
      if (Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleHeight) {
        this.titleHeight = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleHeight;
      }
      if (Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleColor) {
        this.titleColor = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleColor;
      }
      // 弹窗宽度固定 6rem
      if (Vue.prototype?.$storeInstance?.getters?.dialogConfig?.width) {
        this.options.width = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.width;
      }
      /*
         处理三切图
         这里为什么要把三个切图参数都放到backgroundImage，主要是目前所有组件都是透传配置的backgroundImage字段
         这样组件就不用一一改造
         如果配置的图片跟弹窗图片一致，且是|隔开的三切图模式，则返回正确的值
         headerImage,headerWidthRatio|repeatImage,repeatWidthRatio|fotterImage,fotterWidthRatio
      */
      const { backgroundImage } = this.options.dialogStyle;
      if (!backgroundImage) return null;
      const backgroundImageArr = backgroundImage.split('|');
      try {
        const confBg = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.dialogStyle?.backgroundImage;
        console.log('initDialogOption bg=', backgroundImage, '|arr=', backgroundImageArr, '|confBg=', confBg);
        if (backgroundImage === confBg && backgroundImageArr.length === 3) {
          const [headerImage, headerWidthRatio] = backgroundImageArr[0].split(',');
          const [repeatImage, repeatWidthRatio] = backgroundImageArr[1].split(',');
          const [fotterImage, fotterWidthRatio] = backgroundImageArr[2].split(',');

          Object.assign(this.threeImageOption, {
            enable: true,
            headerImage,
            headerWidthRatio: parseFloat(headerWidthRatio),
            repeatImage,
            repeatWidthRatio: parseFloat(repeatWidthRatio),
            fotterImage,
            fotterWidthRatio: parseFloat(fotterWidthRatio),
          });
        }
      } catch (e) {
        console.error('initDialogOption err ', e);
      }
    },
    initDialogHeight() {
      // 打开弹窗时，读取弹窗内容区域高度、弹窗底部高度
      this.$nextTick(() => {
        this.threeRepeatHeight = this.$refs.dialogBody?.offsetHeight;
        console.log('titleHeight', this.titleHeight);
        // 当头部设置为false时，减去头部的默认高度
        if (this.options.header === false) {
          this.threeRepeatHeight -= this.parsePxValue(this.titleHeight);
        }
        // 当底部设置为false时，减去底部的默认高度
        if (this.options.footer === false) {
          this.threeRepeatHeight -= this.parsePxValue(this.isMobile ? '1.44rem' : '80px');
        }
        console.log('this.options', this.options);
        // 动态计算底部高度
        if (this.options.footer) {
          this.threeFooterHeight = this.$refs.dialogFooter?.offsetHeight;
        }
        console.log(
          'threeRepeatHeight==',
          this.threeRepeatHeight, this.threeFooterHeight, this.$refs.dialogBody?.offsetHeight,
          this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingTop || '0px')),
          this.parsePxValue((Vue.prototype?.$storeInstance?.getters?.dialogConfig?.paddingBottom || '0px')),
        );
      });
    },
    parsePxValue(value) {
      let pxValue = 0;
      if (value && /^[-]?[0-9]*[.]?[0-9]*rem$/.test(value)) {
        pxValue = parseFloat(value.substring(0, value.length - 3), 3) * this.multiplier;
      } else {
        pxValue = parseFloat(value.substring(0, value.length - 2), 3);
      }
      console.log(this.multiplier, '|value=', value, '|pxValue=', pxValue);
      return pxValue;
    },
    parseColor(colorStr) {
      return {
        r: parseInt(`${colorStr.slice(1, 3)}`, 16),
        g: parseInt(`${colorStr.slice(3, 5)}`, 16),
        b: parseInt(`${colorStr.slice(5, 7)}`, 16),
      };
    },
    handleClose() {
      if (this.options.close !== false) {
        this.reportFunc(0, 'click_pop', { pop_name: `${this.options.popName || ''}`, type: 'close' });
        this.$emit('close');
      }
      this.close();
    },
    handleClickMask() {
      if (this.options.maskClickable) {
        this.handleClose();
      }
    },
    handleCancel() {
      if (this.options.cancel !== false) {
        this.reportFunc(0, 'click_pop', { pop_name: `${this.options.popName || ''}`, type: 'cancel' });
        this.$emit('cancel');
      }
      this.close();
    },
    handleConfirm() {
      if (this.options.confirm !== false) {
        this.reportFunc(0, 'click_pop', { pop_name: `${this.options.popName || ''}`, type: 'confirm' });
        this.$emit('confirm');
      }
      if (this.options.isConfirmClose) this.close();
    },
    close() {
      {}
    },
    reportFunc(eventType, key, data) {
      if (this.options.popName && typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || '',
          eventType,
          eventKey: key,
          eventData: data || {},
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
        console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ceiba-dialog-container {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    display: flex;
}

.ceiba-dialog-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1001;
    background-color: rgba(0, 0, 0, 0.7);
}

.ceiba-dialog-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1002;
    animation: pop-center-open 0.3s 1;
}

.ceiba-dialog-ft {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.ceiba-dialog-main {
    background: no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    box-sizing: border-box;
    font-size: 0.2rem;
}

.ceiba-dialog-bd {
    // display: flex;
    // justify-content: center;
    // font-size: 0.2rem;
}
// .ceiba-dialog-close-wrap {
//   position: absolute;
//   top: var(--valueTop);
//   right: var(--valueRight);
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

.ceiba-dialog--default .ceiba-dialog-hd {
    position: relative;
    width: 100%;
    text-align: center;
}

.ceiba-dialog--default .ceiba-dialog-title {
    font-size: 0.36rem;
    font-weight: bold;
    height: 0.9rem;
    padding: 0.2rem 0.5rem;
    line-height: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    letter-spacing: 1px;
}

.ceiba-dialog--default .ceiba-dialog-ft-button {
    height: 0.64rem;
    margin: 0.32rem 0;
    min-width: 2.38rem;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.ceiba-dialog--default .ceiba-dialog-close-bottom-center {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // height: 0.64rem;
    // width: 0.64rem;
    bottom: var(--valueTitleHeight);
    margin: 0 auto;
    text-align: center;
    color: #ddd;
    font-size: 0.7rem;
    // background-size: 100% 100%;
}

.ceiba-dialog--default .ceiba-dialog-close-right-top {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // height: 0.64rem;
    // width: 0.64rem;
    right: var(--valueTitleHeight);
    top: 0;
    margin: 0 auto;
    text-align: center;
    color: #ddd;
    font-size: 0.7rem;
    // background-size: 100% 100%;
}
.ceiba-dialog--default .ceiba-dialog-close-top-right {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // height: 0.64rem;
    // width: 0.64rem;
    top: var(--valueTitleHeight);
    right: 0;
    margin: 0 auto;
    text-align: center;
    color: #ddd;
    font-size: 0.7rem;
    // background-size: 100% 100%;
}
.ceiba-dialog--default .ceiba-dialog-close-in-right-top {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: var(--valueTop);
    right: var(--valueRight);
    // height: 0.64rem;
    // width: 0.64rem;
    margin: 0 auto;
    text-align: center;
    color: #ddd;
    font-size: 0.7rem;
    // background-size: 100% 100%;
}

.ceiba-dialog--default .ceiba-dialog-ft-btn-simple {
    display: inline-block;
    color: #fff;
    height: 0.64rem;
    line-height: 0.64rem;
    margin: 0.1rem 0.3rem;
    min-width: 2rem;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    background-color: #a6a6a6;
}
.ceiba-dialog--default .ceiba-dialog-ft-btn-simple--primary {
    background-color: #1D3F7C;
}

/* pc */
.ceiba-dialog-main-pc {
    background: no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 40px 0 0px 0;
    box-sizing: border-box;
    border-radius: 24px;
}
.ceiba-dialog--pc .ceiba-dialog-hd {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-bottom: 24px;
}
.ceiba-dialog--pc .ceiba-dialog-bd {
    // display: flex;
    // justify-content: center;
}
.ceiba-dialog--pc .ceiba-dialog-title {
    font-size: 32px;
    height: 100px;
    padding: 0px 10px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    line-height: 100px;
    letter-spacing: 0px;
    text-align: center;
    color: #242424;
}
.ceiba-dialog--pc .ceiba-dialog-ft {
    display: flex;
    height: 80px;
    line-height: 80px;
    width: 100%;
    // border-top: 1px solid #EBEBEB;
    border-radius: 0 0 24px 24px;
    overflow: hidden;
}
.ceiba-dialog--pc .ceiba-dialog-ft-btn-simple {
    /* height: 42px;
    line-height: 42px;
    margin: 16px 20px;
    min-width: 140px; */
    display: inline-block;
    height: 100%;
    width: 100%;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 80px;
    text-align: center;
    border-right: 1px solid #EBEBEB;
    background-color: #fff;
    border-radius: 0;
    color: #8e8e93;
    flex: 1;
    min-width: 0;
    margin: 0;
}
.ceiba-dialog--pc .ceiba-dialog-ft-btn-simple--primary {
    color: #1D3F7C;
    background-color: #fff;
    font-size: 16px;
}
.ceiba-dialog--pc .ceiba-dialog-ft-button {
    /* height: 42px;
    margin: 16px 20px;
    min-width: 140px; */
    min-width: 0;
    margin: 0;
    display: inline-block;
    height: 100%;
    width: 50%;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 80px;
    text-align: center;
    border-right: 1px solid #EBEBEB;
    border-radius: 0;
    color: #8e8e93;
    flex: 1;
}
.ceiba-dialog--pc .ceiba-dialog-ft-button:nth-child(1) {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 500;
    line-height: 48px;
    letter-spacing: 0px;
    text-align: center;
    color: #8E8E93;
}
.ceiba-dialog--pc .ceiba-dialog-ft-button:nth-child(2) {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 500;
    line-height: 48px;
    letter-spacing: 0px;
    text-align: center;
    border-right: 0;
}

.ceiba-dialog--pc .ceiba-dialog-close-bottom-center {
    // height: 40px;
    // width: 40px;
    bottom: -45px;
    font-size: 40px;
}
.ceiba-dialog--pc .ceiba-dialog-close-right-top {
    // height: 40px;
    // width: 40px;
    right: -45px;
    top: 0;
    font-size: 40px;
}
.ceiba-dialog--pc .ceiba-dialog-close-top-right {
    // height: 32px;
    // width: 32px;
    top: -44px;
    right: -16px;
    font-size: 40px;
}

.ceiba-dialog--pc .ceiba-dialog-close-in-right-top {
    // height: 40px;
    // width: 40px;
    top: var(--valueTop);
    right: var(--valueRight);
    font-size: 40px;
}

.ceiba-dialog-main-bottom {
    border-radius: 0.48rem 0.48rem 0 0;
    padding: 20px 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position:center;

}


.ceiba-dialog-wrap-isBottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1002;
    border-radius: 15px 15px 0 0;
    animation: pop-bottom-open 0.3s 1;
}


.ceiba-dialog-wrap-isBottom-close-animation{
    animation: pop-bottom-close 0.3s 1;
    bottom: var(--onPopHeight);
}

/* 从底部弹框出现 */
@keyframes pop-bottom-open {
    0% {
        bottom: var(--onPopHeight);
    }

    100% {
        bottom: 0;
    }
}

/* 从底部弹框消失 */
@keyframes pop-bottom-close {
    0% {
        bottom: 0;
    }

    100% {
        bottom: var(--onPopHeight);
    }
}

@-webkit-keyframes pop-bottom-close {
    0% {
        bottom: 0;
    }

    100% {
        bottom: var(--onPopHeight);
    }
}
.ceiba-dialog-wrap-close-animation {
    animation: pop-center-close 0.3s 1;
}

@keyframes pop-center-open {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0, 0, 1);
        transform: scale3d(0, 0, 1);
    }

    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}

@keyframes pop-center-close {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        -webkit-transform: scale3d(0.5, 0.5, 1);
        transform: scale3d(0.5, 0.5, 1);
    }
}

@-webkit-keyframes pop-center-close {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        -webkit-transform: scale3d(0.5, 0.5, 1);
        transform: scale3d(0.5, 0.5, 1);
    }
}


.ceiba-dialog--default .ceiba-base-bottom-dialog-title {
    height: 1.2rem;
    line-height: 1.2rem;
    /* padding: 0.2rem 0.5rem; */
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    font-size: 0.32rem;
    font-weight: 500;
    padding-left: 0.5rem;
}

/* close button style */
.ceiba-dialog--default .ceiba-dialog-close-top-right-isBottom {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // height: 0.04rem;
    // width: 0.04rem;
    right: 0rem;
    top: 0rem;
    margin: 0 auto;
    text-align: center;
    color: #ddd;
    font-size: 0.7rem;
    // background-size: 100% 100%;
}

.ceiba-dialog-main-bg {
    position: fixed;

    .ceiba-dialog-main-bg-header {
        width: 100%;
    }

    .ceiba-dialog-main-bg-body {
        width: 100%;
        margin-top: -1px;
    }

    .ceiba-dialog-main-bg-footer {
        // position: absolute;
        // bottom: 0;
        width: 100%;
    }
}
</style>
